const extractYachtAndContactsFromContactData = data => {
  const contacts = (data.businessContactComponentContacts || []).map(contactData => ({
    brokerBranchId: contactData.brokerBranchId || null,
    brokerId: data.brokerId || null,
    brokerName: data.brokerId ? contactData.name : null,
    businessContactId: null,
    exhibitorId: contactData.exhibitorId,
    image: { ...contactData.image },
    internalUrl: contactData.internalUrl,
    name: contactData.name,
    phone: contactData.phone,
    type: data.brokerId ? 'broker' : 'exhibitor',
    website: null
  }));
  if (contacts.length === 0) return null;

  let yachtData = null;
  if (data.length_overall && data.built_on_year) {
    yachtData = {
      id: data.yachtPageId || null,
      builders: data.publishedBuilderProfiles.map(profileData => profileData.name).join(', '),
      builtOnYear: data.built_on_year,
      currency: (data.currency || {}).code || '',
      entity: null,
      formattedPrice: null,
      image: data.image,
      isSponsored: false,
      lengthOverall: `${data.length_overall}m`,
      name: data.name,
      price: data.entity === 'yacht_for_charter' ? data.weeklyLowRate : data.price,
      primaryCategory: (data.category || {}).name || '',
      promotionType: null,
      yachtForCharterId: null,
      yachtForSaleId: null,
      yachtPageId: data.yachtPageId
    };
  }

  return { yachtData, contacts };
};

export default extractYachtAndContactsFromContactData;
